import { Component, Input, Output, EventEmitter } from '@angular/core';

export interface DesignFile {
  file: File;
  preview: string;
  position: 'Front' | 'Back' | 'Left' | 'Right';
}

@Component({
  selector: 'app-upload-design',
  templateUrl: './upload-design.component.html',
  styleUrls: ['./upload-design.component.scss']
})
export class UploadDesignComponent {
  @Input() disabled: boolean = false;
  @Output() filesSelected = new EventEmitter<DesignFile[]>();
  @Output() submitDesign = new EventEmitter<DesignFile[]>();

  designFiles: DesignFile[] = [
    { file: null, preview: null, position: 'Front' },
    { file: null, preview: null, position: 'Back' },
    { file: null, preview: null, position: 'Left' },
    { file: null, preview: null, position: 'Right' }
  ];

  onFileSelected(event: any, position: 'Front' | 'Back' | 'Left' | 'Right'): void {
    const file = event.target.files[0];
    if (file) {
      const designFile = this.designFiles.find(df => df.position === position);
      if (designFile) {
        designFile.file = file;
        
        // Create preview
        const reader = new FileReader();
        reader.onload = (e: any) => {
          designFile.preview = e.target.result;
        };
        reader.readAsDataURL(file);
      }
      
      // Emit the updated files
      this.filesSelected.emit(this.designFiles.filter(df => df.file !== null));
    }
  }

  removeFile(position: 'Front' | 'Back' | 'Left' | 'Right'): void {
    const designFile = this.designFiles.find(df => df.position === position);
    if (designFile) {
      designFile.file = null;
      designFile.preview = null;
    }
    
    // Emit the updated files
    this.filesSelected.emit(this.designFiles.filter(df => df.file !== null));
  }

  onSubmitDesign(): void {
    const filesToSubmit = this.designFiles.filter(df => df.file !== null);
    if (filesToSubmit.length > 0) {
      this.submitDesign.emit(filesToSubmit);
    }
  }

  hasFiles(): boolean {
    return this.designFiles.some(df => df.file !== null);
  }

  getFileCount(): number {
    return this.designFiles.filter(df => df.file !== null).length;
  }

  formatFileSize(bytes: number): string {
    if (bytes === 0) return '0 Bytes';
    const k = 1024;
    const sizes = ['Bytes', 'KB', 'MB', 'GB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
  }

  getRowFiles(position1: string, position2: string): DesignFile[] {
    return this.designFiles.filter(df => df.position === position1 || df.position === position2);
  }
}
